import React, { Component } from 'react';
import FadeIn from '../components/FadeIn'


class NotFound extends Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
	
	}

	componentWillUnmount() {

	}

  

	/*
		
		RENDER

	*/

	render() {



		return (
			<div>
				<h1><br/>PAGE NOT FOUND</h1>
			</div>
		);

	}
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/js/templates/Error.js